<script lang="ts">
    export let url:string = "";
    import QrCode from "svelte-qrcode";
</script>

<div class="qrcode">
    <QrCode value="{url}" />
</div>

<style lang="scss">
    .qrcode {
        text-align: center;
    }
</style>
